const convertDate = (date?: number): string => {
  if (date == undefined) {
    return "";
  }
  return new Date(date * 1000).toISOString().split("T")[0];
};

const convertDateIso = (date?: string): string => {
  if (date == undefined) {
    return "";
  }
  return new Date(date).toISOString().split("T")[0];
};
const convertDateBrComHora = (date?: number) => {
  if (date == undefined) {
    return "";
  }
  return new Date(date * 1000).toLocaleString("en-GB");
};

const convertDateBr = (date?: number) => {
  if (date == undefined) {
    return "";
  }

  const myDate = new Date(date * 1000);
  return (
    myDate.getUTCDate() +
    "/" +
    (myDate.getUTCMonth() + 1 + "").padStart(2, "0") +
    "/" +
    myDate.getUTCFullYear()
  );
  // return new Date(date * 1000).toLocaleDateString("en-GB");
};

const convertDateUs = (date?: number) => {
  if (date == undefined) {
    return "";
  }
  return new Date(date * 1000).toLocaleDateString();
};

const convertStringDateToBr = (date?: string) => {
  if (date == undefined) {
    return "";
  }
  const [year, month, day] = date.split("-");
  const formattedDate = `${day}/${month}/${year}`;
  return formattedDate;
};

const getFullYear = () => {
  const dataAtual = new Date();
  return dataAtual.getFullYear();
};

const convertTimeStampToDate = (timestamp?: number) => {
  if (timestamp == undefined) {
    return "";
  }
  const data = new Date(timestamp * 1000);
  return data.toISOString().split("T")[0];
};

const convertYearMonthToInput = (
  yearMonth?: string | number | null
): string => {
  if (yearMonth === null || yearMonth === undefined) {
    return "";
  }

  const normalizedYearMonth = yearMonth.toString().trim();

  if (/^\d{6}$/.test(normalizedYearMonth)) {
    return `${normalizedYearMonth.slice(0, 4)}-${normalizedYearMonth.slice(4)}`;
  }

  if (/^\d{4}-\d{2}/.test(normalizedYearMonth)) {
    return normalizedYearMonth.slice(0, 7);
  }

  return normalizedYearMonth;
};

const tomorrowDate = () => {
  const tomorrow = new Date();
  const timestamp = tomorrow.setDate(tomorrow.getDate() + 1);
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  return year + "-" + month + "-" + day;
};
export {
  convertDate,
  convertDateIso,
  convertDateBr,
  convertDateUs,
  convertStringDateToBr,
  getFullYear,
  tomorrowDate,
  convertDateBrComHora,
  convertTimeStampToDate,
  convertYearMonthToInput,
};
